import { useTranslation } from '@thoughtspot/i18n';
import { Divider } from '@thoughtspot/radiant-react/widgets/divider';
import React, { useEffect, useState } from 'react';
import { useGetAdminAlertsQuery, useGetAdminEventsQuery, } from "../../../services/system/system-service";
import { Horizontal, Vertical } from "../../../utils/layouts";
import { Header, WithQueryHandler } from '../common';
import { AlertTable } from './alert';
import styles from './alert.module.scss';
import { dataColumnsAlerts, dataColumnsEvents, prepareTableRowDataAlerts, prepareTableRowDataEvents, } from './util';
const filterEventsByType = (items) => {
    const configEvents = items.filter((event) => event.type === 'CONFIG');
    const notificationEvents = items.filter((event) => event.type === 'NOTIFICATION');
    return { configEvents, notificationEvents };
};
export const AlertContainer = () => {
    const { t } = useTranslation();
    const { data, error, loading } = useGetAdminEventsQuery();
    const { data: dataAlert, error: errorAlert, loading: loadingAlert, } = useGetAdminAlertsQuery();
    const [tableRowDataAlert, setTableRowDataAlert] = useState();
    const [tableRowDataNotificationEvents, setTableRowDataNotificationEvents,] = useState();
    const [tableRowDataConfigurationEvents, setTableRowDataConfigurationEvents,] = useState();
    useEffect(() => {
        if (data && !loading) {
            const { configEvents, notificationEvents } = filterEventsByType(data.Admin_getEvents.event);
            setTableRowDataConfigurationEvents(prepareTableRowDataEvents(configEvents));
            setTableRowDataNotificationEvents(prepareTableRowDataEvents(notificationEvents));
        }
    }, [data, loading]);
    useEffect(() => {
        if (dataAlert && !loadingAlert) {
            const tableRowData = prepareTableRowDataAlerts(dataAlert);
            setTableRowDataAlert(tableRowData);
        }
    }, [dataAlert, loadingAlert]);
    const renderContent = () => (React.createElement(Vertical, null,
        React.createElement(Header, { title: t('adminSection.system.alert'), titleSize: "large", isFullWidth: true }),
        React.createElement(Divider, null),
        React.createElement(Horizontal, { className: styles.alertBody },
            React.createElement(Horizontal, null,
                React.createElement(AlertTable, { tableRowData: tableRowDataAlert, title: t('adminPortal.alerts.title'), dataColumns: dataColumnsAlerts })),
            React.createElement(Horizontal, { className: styles.configEvents },
                React.createElement(AlertTable, { tableRowData: tableRowDataConfigurationEvents, title: t('adminPortal.configurationEvents.title'), dataColumns: dataColumnsEvents }))),
        React.createElement(Horizontal, { className: styles.alertSecondPart },
            React.createElement(AlertTable, { tableRowData: tableRowDataNotificationEvents, title: t('adminPortal.notificationEvents.title'), dataColumns: dataColumnsEvents }))));
    return renderContent();
};
export const Alert = () => {
    return (React.createElement(WithQueryHandler, null,
        React.createElement(AlertContainer, null)));
};
//# sourceMappingURL=alert-tab.container.js.map